import create from 'utils/createReduxPromiseActionType'

export const SET_IS_GRID = 'wedding/SET_IS_GRID'
export const WEDDING_LIST = create('wedding/WEDDING_LIST')
export const LOAD_WEDDING = create('wedding/LOAD_WEDDING')
export const REMOVE = create('wedding/REMOVE')
export const UPDATE = create('wedding/UPDATE')
export const ADD = create('wedding/ADD')
export const LOAD_DEFAULT_IMAGES = create('wedding/LOAD_DEFAULT_IMAGES')
export const JOIN_TO_WEDDING = create('wedding/JOIN_TO_WEDDING')
export const OFFER_CODE = create('wedding/OFFER_CODE')
export const CHECK_CODE = create('wedding/CHECK_CODE')
